export const baseUrlMapper = {
  beta: 'https://api.ronhan.com',
  development: 'https://api.ronhan.com',
  testing: 'https://test-api.ronhan.com',
  sit: 'https://test-api.ronhan.com',
  uat: 'https://uat-api.ronhan.com',
  production: 'https://api.onerway.com',
};

export const apiKeyMapper = {
  beta: 'ChkotfJTPA7D8JvgysJJ8lylz9wmJusF',
  development: 'ChkotfJTPA7D8JvgysJJ8lylz9wmJusF',
  testing: 'HBfFTVjSQ4G16DXYdUqzRYGUDAOhFSCj',
  sit: 'HBfFTVjSQ4G16DXYdUqzRYGUDAOhFSCj',
  uat: 'QZUG1EeTQD1XoqwJnTPg20a2xurQYsCY',
  production: 'lu9OuATOj3IGAKJQDBv0Crx4EQ3dXfaY',
};
